import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { createMessagesGetter, toMessageProps } from 'Components/Worksheets/Core/Helpers/messageHelpers';
import { CurveFittingAlgorithm } from 'Components/Worksheets/Shared/types';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import deepEquals from '../../../../Lib/Object/deepEquals';
import { Field, NumericInput, RadioGroup } from '../../../Core';
import { ChartFieldSection, ListFieldSection } from '../../../Layout';

type CwdChartSectionProps = IWorksheetComponent & {
  hideCurveFittingSelection?: boolean;
  visible?: boolean;
};
let CwdChartSection: React.FC<CwdChartSectionProps> = ({
  createWorksheetSelector = undefined,
  hideCurveFittingSelection = true,
  visible = true,
}) => {
  const chart = useSelector(createWorksheetSelector!('cwdChart.Chart', false));
  const chartMessages = useSelector(
    pipe(createWorksheetSelector!('cwdChart.Messages', false), createMessagesGetter('Chart')),
    deepEquals
  );
  const isScalingManual = useSelector(pipe(createWorksheetSelector!('cwdChart.ScaleMode', false), (m) => m === 2));

  const yToXAxisStepRatioOptions = useSelector(
    pipe(createWorksheetSelector!('cwdChart.YAxisToXAxisStepRatios', false), (ratios) =>
      ratios?.map((r: Number) => ({
        value: r,
        label: `${r}:1`,
      }))
    ),
    deepEquals
  );

  return !visible ? null : (
    <>
      <ChartFieldSection chart={chart} messages={chartMessages.map(toMessageProps)} />
      <ListFieldSection>
        <NamePrefixModifier namePrefix={'cwdChart'}>
          <Field
            input={<RadioGroup />}
            label="Chart Scaling"
            name={'ScaleMode'}
            options={[
              { label: 'Automatic', value: 1 },
              { label: 'Manual', value: 2 },
            ]}
          />
          {isScalingManual && (
            <>
              <Field input={<RadioGroup />} name={'YAxisToXAxisStepRatio'} options={yToXAxisStepRatioOptions} />
              <Field input={<NumericInput />} name="XAxisMin" />
              <Field input={<NumericInput />} name="XAxisMajorStep" />
            </>
          )}
        </NamePrefixModifier>
        {!hideCurveFittingSelection && (
          <Field
            input={<RadioGroup />}
            label="Curve Fitting"
            name={'Results.CwdCurveFittingAlgorithm'}
            options={[
              { label: 'Bézier curve', value: CurveFittingAlgorithm.Bezier },
              { label: 'Cubic spline', value: CurveFittingAlgorithm.CubicSpline },
            ]}
          />
        )}
      </ListFieldSection>
    </>
  );
};

CwdChartSection = withInjectedProps(CwdChartSection);

export { CwdChartSection };
export default CwdChartSection;
